var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.5V6.5M11 6.5V8.5M11 6.5H13M11 6.5H9M7.5 3.75C7.5 4.99264 6.49264 6 5.25 6C4.00736 6 3 4.99264 3 3.75C3 2.50736 4.00736 1.5 5.25 1.5C6.49264 1.5 7.5 2.50736 7.5 3.75ZM1.00061 12.3229C1.00021 12.2986 1 12.2743 1 12.25C1 9.90279 2.90279 8 5.25 8C7.59721 8 9.5 9.90279 9.5 12.25V12.2517C9.49999 12.2755 9.49978 12.2992 9.49939 12.3229C8.25824 13.0702 6.80432 13.5 5.25 13.5C3.69568 13.5 2.24176 13.0702 1.00061 12.3229Z",
    stroke: "#FDFDFD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.545c3679e51380784b0767317b614444.svg";
export { ForwardRef as ReactComponent };